export default __webpack_public_path__ + "static/media/main.ae918002.jpg";